<script setup lang="ts">
import ImagePlaceholderIcon from '@/assets/icons/Profile/ImagePlaceholderIcon.vue';
import { useImageBase64 } from '@/composables/useImageBase64';
import type { Employee } from '@/types/api';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import WorkingStatus from './WorkingStatus.vue';

const props = defineProps<{
  user: Employee;
}>();

const router = useRouter();
const { t } = useI18n();

const photoUrl = computed(() => props.user?.profile_picture_url ?? null);
const { imageSrc } = useImageBase64(photoUrl);

function navigateToUserDetail() {
  router.push(`/profile/team/${props.user.id}`);
}
</script>
<template>
  <div class="relative flex cursor-pointer items-center gap-4 rounded-2xl border-2 border-primary-300 p-4 shadow-md" @click="navigateToUserDetail">
    <div
      class="relative flex aspect-square h-12 max-h-12 w-12 max-w-12 items-center justify-center rounded-full border-2 border-accent object-cover p-1"
    >
      <img
v-if="imageSrc" :src="imageSrc"
        alt="Profile picture"
        class="absolute inset-0 h-full w-full rounded-full object-cover p-1"
      />
      <ImagePlaceholderIcon v-else class="h-5 w-5 text-primary-950" />
    </div>
    <div class="mb-7 grow">
      <div class="flex justify-between">
        <h4>{{ user.first_name }} {{ user.last_name }}</h4>
        <i class="pi pi-angle-right text-lg"></i>
      </div>
      <div class="flex flex-wrap gap-2 text-sm">
        {{ t('employee.kitchenPositions.positions.' + (user.kitchen_position?.name ?? 'noPosition')) }}
      </div>
    </div>
    <WorkingStatus :currently-working="user.is_currently_working" classes="absolute bottom-4 right-4" size="sm" />
  </div>
</template>
